var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85806 3.60325C5.97046 3.43465 6.1597 3.33337 6.36233 3.33337H13.6351C13.8377 3.33337 14.0269 3.43465 14.1393 3.60325L16.5636 7.23962C16.7032 7.44912 16.6988 7.72317 16.5525 7.92806L10.4919 16.4129C10.3781 16.5722 10.1944 16.6667 9.9987 16.6667C9.80297 16.6667 9.61929 16.5722 9.50553 16.4129L3.44492 7.92806C3.29857 7.72317 3.29415 7.44912 3.43382 7.23962L5.85806 3.60325ZM6.68669 4.5455L5.07053 6.96974H7.13763L7.94571 4.5455H6.68669ZM9.2234 4.5455L8.41532 6.96974H11.5821L10.774 4.5455H9.2234ZM12.0517 4.5455L12.8598 6.96974H14.9269L13.3107 4.5455H12.0517ZM14.8816 8.18186H12.8801L11.5457 12.8521L14.8816 8.18186ZM9.9987 13.8546L11.6195 8.18186H8.37793L9.9987 13.8546ZM7.1173 8.18186L8.45165 12.8521L5.11578 8.18186H7.1173Z",
    fill: "currentColor",
    fillOpacity: 0.72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.e3a4e95522165cbcd52c7767cd81d765.svg";
export { ForwardRef as ReactComponent };